"use strict";

import { of, from } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, window } from "rxjs/operators";

import {
     requestTypes,
     dataUploadConstants,
     commonConstants,
     FILE_UPLOAD_URL,
} from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";
import {
     ajaxError,
     dataUploadAddComplete,
     dataUploadDataProcessingRecodeComplete,
     dataUploadDataTemplateListComplete,
     dataUploadSilentListComplete,
     dataUploadDownloadSummaryComplete,
     dataUploadListComplete,
     dataUploadSummeryComplete,
     imageUploadComplete,
     dataFileTypeListCompelete,
     dataFileSchemaCompelete,
     dataUploadRecordCountComplete,
     downloadSchemaTempComplete,
     downloadActiveRecordsComplete,
     downloadDeletedRecordsComplete,
     imageUploadError,
} from "../_actions";

export const dataUploadDataTemplateListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_UPLOAD_DATA_TEMPLATE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataUpload/dataTemplateList",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataUploadDataTemplateListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataUploadSilentListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_UPLOAD_LIST_SILENT_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataUpload/list",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataUploadSilentListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataUploadListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_UPLOAD_LIST_REQUEST),
          mergeMap((action) => {
               return ajax

                    .post(
                         "/api/dataUpload/list",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataUploadListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataUploadAddEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_UPLOAD_ADD_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataUpload/add",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataUploadAddComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataUploadSummeryEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_UPLOAD_SUMMERY_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataUpload/summery",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataUploadSummeryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataUploadDataProcessingRecodeEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dataUploadConstants.DATA_UPLOAD_DATA_PROCESSING_RECORD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataUpload/dataProcessingRecord",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataUploadDataProcessingRecodeComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataUploadDownloadSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_UPLOAD_DATA_DOWNLOAD_SUMMARY_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dataUpload/downloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              const link = document.createElement("a");
                              link.href = ajaxResponse.response.downloadUrl;
                              document.body.appendChild(link);
                              link.click();
                              return dataUploadDownloadSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const imageUploadEpic = (actions$) => {
     return actions$.pipe(
          ofType(commonConstants.IMAGE_UPLOAD_REQUEST),
          mergeMap((action) => {
               const formData = new FormData();
               formData.append("file", action.payload.file);
          return from(
                fetch("/api/auth/upload-profile-pic", {
                    method: "POST",
                    body: formData,
                }),
            ).pipe(
                mergeMap((response) => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return from(response.json()).pipe(
                        mergeMap((responseData) => {
                            return of(
                                imageUploadComplete({
                                   data: responseData?.data,
                                   type: action.payload.type,
                                }
                                    
                                ),
                            );
                        }),
                        catchError((error) => of(imageUploadError(error))),
                    );
                }),
                catchError((error) => of(imageUploadError(error))),
            );
          }),
     );
};



export const dataFileTypeListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_FILE_TYPE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax

                    .post(
                         "/api/dataUpload/fileTypeList",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataFileTypeListCompelete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataFileSchemaListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_FILE_SCHEMA_REQUEST),
          mergeMap((action) => {
               return ajax

                    .post(
                         "/api/dataUpload/fileSchemaList",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataFileSchemaCompelete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dataUploadRecordCountEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_UPLOAD_RECORD_COUNT_REQUEST),
          mergeMap((action) => {
               return ajax

                    .post(
                         "/api/dataUpload/recordsCount",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dataUploadRecordCountComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const downloadSchemaTempEpic = (actions$) => {
     return actions$.pipe(
          ofType(dataUploadConstants.DATA_UPLOAD_DOWNLOAD_SCHEMA_TEMP_REQUEST),
          mergeMap((action) => {
               return ajax

                    .post(
                         "/api/dataUpload/downloadSchemaTemp",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              const link = document.createElement("a");
                              link.href = ajaxResponse.response.downloadUrl;
                              document.body.appendChild(link);
                              link.click();
                              return downloadSchemaTempComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const downloadActiveRecordsEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dataUploadConstants.DATA_UPLOAD_DOWNLOAD_ACTIVE_RECORDS_REQUEST,
          ),
          mergeMap((action) => {
               return ajax

                    .post(
                         "/api/dataUpload/downloadActiveRecords",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              const link = document.createElement("a");
                              link.href = ajaxResponse.response.downloadUrl;
                              document.body.appendChild(link);
                              link.click();
                              return downloadActiveRecordsComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const downloadDeleteRecordsEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dataUploadConstants.DATA_UPLOAD_DOWNLOAD_DELETED_RECORDS_REQUEST,
          ),
          mergeMap((action) => {
               return ajax

                    .post(
                         "/api/dataUpload/downloadDeleteRecords",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              window.open(ajaxResponse.response.downloadUrl);
                              return downloadDeletedRecordsComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};
